import { useAuth } from '@/contexts/AuthContext';
import { ScopeCode } from '@/constants/scopeCodes';

export const useScope = (requiredScope?: ScopeCode | ScopeCode[]): boolean => {
  const { scopes, isSuperuser } = useAuth();

  if (!requiredScope || requiredScope.length === 0) return true;

  if (isSuperuser) return true;

  const scopesToCheck = Array.isArray(requiredScope) ? requiredScope : [requiredScope];

  return scopesToCheck.some(scope => scopes.includes(scope));
};